/* soyu-cart.js — le tiroir panier SOYU, clone du tiroir de somnairlabs.com (Somnair Pet).
   Styles : soyu-cart.css. Blocs Liquid : config/settings_data.json -> sections.cart-drawer
   (posés par api/34_cart_drawer.py).

   Repris de DEUX fichiers Somnair, sans leur logique propre à la marque :
     · somnair-cart.js : bascule one-time -> abonnement [data-syc-up], switch
       « Priority Shipping & Protection » [data-syc-prot] PRÉ-COCHÉ (opt-out), carte
       cross-sell [data-syc-xs], garde « protection seule », repeint sans clignotement ;
     · somnair-ob.js (partie tiroir) : bandeau d'objectif, récapitulatif « Discounts /
       Subtotal » + icônes de paiement, libellé « Checkout • total », ouverture
       immédiate du tiroir avec squelette à l'ajout au panier.
   Pas repris : le filet des lignes cadeau (SOYU n'a aucun produit cadeau).

   Tout est délégué sur `document` : Shrine REMPLACE #CartDrawer à chaque repaint
   (renderContents), aucun listener posé sur le markup du tiroir ne survivrait. */
(function () {
  'use strict';
  if (window.__soyuCartBound) return;
  window.__soyuCartBound = true;

  var PROT_HANDLE = 'soyu-shipping-protection';
  var PROT_OPTOUT = 'soyu:prot-optout';
  var FOOTER_SEL = '.drawer__footer, .cart-drawer__footer';

  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function attendre(ms) {
    return new Promise(function (r) { setTimeout(r, ms); });
  }

  function sectionIds(d) {
    try {
      if (d && typeof d.getSectionsToRender === 'function') {
        return d.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) { /* défauts ci-dessous */ }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function withSections(payload, d) {
    payload.sections = sectionIds(d);
    payload.sections_url = window.location.pathname;
    return payload;
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status && response.status !== 200) {
          throw new Error(response.description || response.message || 'cart error');
        }
        return response;
      });
  }

  function cartRead() {
    return fetch(route('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        /* 429 anti-bot : la réponse est une PAGE HTML, pas du JSON. */
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      });
  }

  function money(cents, cart) {
    var cur = (cart && cart.currency) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US',
        { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* ======================================================== HABILLAGE DU TIROIR */

  /* Vrai pendant que l'on écrit dans le pied : l'observateur ne doit pas repartir
     sur nos propres insertions. */
  var skinning = false;

  function cartState() {
    try {
      var el = document.getElementById('syc-cart-state');
      if (el) return JSON.parse(el.textContent);
    } catch (e) { /* valeurs par défaut */ }
    return null;
  }

  /* Bandeau d'objectif : « Add {reste} to unlock Free shipping! » puis « Free shipping
     unlocked! ». Le seuil vient de #syc-cart-state (bloc du tiroir), en centimes de la
     devise du panier. Chez SOYU il vaut 0 : la livraison US est offerte sur toute
     commande (api/25_livraison_us.py) — le bandeau dit donc toujours la vérité. */
  function goalBar(cd, cart) {
    var txt = cd.querySelector('.cart-progress__text');
    var bar = cd.querySelector('.cart-progress__bar');
    if (!txt && !bar) return;
    var st = cartState();
    var goal = st && typeof st.goal === 'number' ? st.goal : 0;
    var cur = (cart && cart.currency) || (st && st.currency);
    if (st && st.goals && cur && typeof st.goals[cur] === 'number') goal = st.goals[cur];
    var total = cart ? cart.total_price : (st ? st.total : 0);
    var left = Math.max(0, goal - total);
    if (txt) {
      var t = left > 0 ? 'Add ' + money(left, cart) + ' to unlock Free shipping!' : 'Free shipping unlocked!';
      if (txt.textContent.trim() !== t) txt.textContent = t;
    }
    var fill = bar && bar.firstElementChild;
    if (fill) fill.style.width = (goal > 0 ? Math.min(100, Math.round(total / goal * 100)) : 100) + '%';
  }

  /* « Checkout • $38.00 » : le total vient du panier lu, pas du Liquid figé. */
  function skinCheckout(cd, cart) {
    var btn = cd.querySelector('#CartDrawer-Checkout, button[name=checkout]');
    if (!btn) return;
    var lab = btn.querySelector('.button__label') || btn;
    var t = 'Checkout • ' + money(cart.total_price, cart);
    if (lab.textContent.trim() !== t) lab.textContent = t;
  }

  /* Récapitulatif de bas de tiroir : « Discounts » (masqué s'il vaut zéro) puis
     « Subtotal », au-dessus du bouton ; icônes de paiement en dessous.
     TOUT vient de /cart.js et du bloc #syc-cart-ca (re-rendu à chaque repaint) :
     /cart.js n'expose pas le prix de référence, le Liquid si. Référence d'une ligne =
     le prix barré de la variante, ou à défaut son prix d'achat unique — c'est ce qui
     fait apparaître l'économie d'une ligne en abonnement (67 $ -> 38 $). */
  function buildSummary(cd) {
    var tpl = document.getElementById('syc-cart-summary');
    var footer = cd.querySelector(FOOTER_SEL);
    if (!tpl || !footer) return Promise.resolve();
    skinning = true;
    return cartRead()
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) { skinning = false; return; }
        var f = cd.querySelector(FOOTER_SEL);
        if (!f) { skinning = false; return; }
        ['.syc-cs', '.syc-cs__pay'].forEach(function (sel) {
          var o = f.querySelector(sel);
          if (o) o.parentNode.removeChild(o);
        });
        var node = tpl.content.cloneNode(true);

        var ref = {};
        try {
          var el = document.getElementById('syc-cart-ca');
          if (el) ref = JSON.parse(el.textContent) || {};
        } catch (e) { /* pas de référence : pas de prix barré */ }
        var sub = node.querySelector('[data-syc-cs-sub]');
        if (sub) sub.textContent = money(cart.items_subtotal_price, cart);
        node.querySelector('[data-syc-cs-total]').textContent = money(cart.total_price, cart);
        prixBarres(cd, cart, ref);

        /* Ordre du pied (calque OMNI) : offre UPGRADE -> Subtotal / Shipping / Total ->
           bouton -> icônes. La carte d'offre est un bloc du pied, déjà en tête. */
        var rows = node.querySelector('.syc-cs');
        var pay = node.querySelector('.syc-cs__pay');
        var ctas = f.querySelector('.cart__ctas');
        if (rows) {
          if (ctas && ctas.parentNode === f) f.insertBefore(rows, ctas);
          else f.insertBefore(rows, f.firstChild);
        }
        if (pay) {
          if (ctas && ctas.parentNode === f) f.insertBefore(pay, ctas.nextSibling);
          else f.appendChild(pay);
        }
        skinCheckout(cd, cart);
        goalBar(cd, cart);
        skinning = false;
      })
      .catch(function () { skinning = false; skinEchec = Date.now(); });
  }

  /* Dernier échec de lecture du panier (429 anti-bot) : on ne réessaie pas avant 3 s,
     sinon chaque mutation du tiroir relancerait un /cart.js. */
  var skinEchec = 0;

  /* Prix barré + « 43% OFF » sur une ligne qui n'en a pas (calque OMNI) : une ligne en
     abonnement à 38 $ n'a pas de compare_at, sa référence est le prix d'achat unique
     (#syc-cart-ca). Les lignes rendues par Shrine portent l'id CartDrawer-Item-<n>, n = rang
     dans /cart.js. Rien n'est ajouté si la ligne a déjà son prix barré natif. */
  function prixBarres(cd, cart, ref) {
    cart.items.forEach(function (it, i) {
      var li = cd.querySelector('#CartDrawer-Item-' + (i + 1));
      if (!li || li.querySelector('.cart-item__old-price, .syc-was')) return;
      var r = (ref[String(it.variant_id)] || 0) * it.quantity;
      if (!(r > it.final_line_price)) return;
      var prix = li.querySelector('.cart-item__price-wrapper .regular-price');
      if (!prix) return;
      var was = document.createElement('s');
      was.className = 'syc-was';
      was.textContent = money(r, cart);
      prix.parentNode.insertBefore(was, prix);
      var pct = document.createElement('span');
      pct.className = 'syc-pct';
      pct.textContent = Math.round((r - it.final_line_price) * 100 / r) + '% OFF';
      prix.parentNode.appendChild(pct);
    });
  }

  function skinDrawer() {
    var cd = drawer();
    if (!cd) return Promise.resolve();
    return buildSummary(cd);
  }

  /* Le récapitulatif manque (le thème a repeint le pied) : on le repose. */
  function ensureSkin() {
    if (skinning || Date.now() - skinEchec < 3000) return;
    var cd = drawer();
    if (!cd) return;
    var footer = cd.querySelector(FOOTER_SEL);
    if (!footer || footer.querySelector('.syc-cs')) return;
    if (!cd.querySelector('.cart-item')) return;
    skinDrawer();
  }

  /* ------------------------------------------ ouverture immédiate à l'ajout */
  var enterTimer = null;

  function enterContent(cd) {
    cd.classList.remove('syc-in');
    void cd.offsetWidth;
    cd.classList.add('syc-in');
    clearTimeout(enterTimer);
    enterTimer = setTimeout(function () { cd.classList.remove('syc-in'); }, 420);
  }

  function openDrawer(loading) {
    var cd = drawer();
    if (!cd) return null;
    cd.classList.remove('is-empty');
    cd.classList.add('active', 'animate');
    if (loading) cd.classList.add('syc-loading');
    document.body.classList.add('overflow-hidden');
    return cd;
  }

  function swapDrawer(html) {
    var cd = drawer();
    if (!cd) return;
    if (html) {
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        if (fresh) cd.innerHTML = fresh.innerHTML;
      } catch (e) { /* on garde l'ancien contenu */ }
    }
    var wasLoading = cd.classList.contains('syc-loading');
    cd.classList.toggle('is-empty', !!cd.querySelector('.drawer__inner-empty'));
    if (!wasLoading) { skinDrawer(); return; }
    /* Première ouverture : on garde le squelette jusqu'à ce que le pied soit complet,
       puis on dévoile tout d'un coup (plafond 400 ms). */
    var revealed = false;
    var reveal = function () {
      if (revealed) return;
      revealed = true;
      cd.classList.remove('syc-loading');
      enterContent(cd);
    };
    setTimeout(reveal, 400);
    skinDrawer().then(reveal, reveal);
  }

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        swapDrawer(j && j['cart-drawer']);
        majBulle(j && j['cart-icon-bubble']);
      })
      .catch(function () { swapDrawer(null); });
  }

  function majBulle(html) {
    if (!html) return;
    var h = document.createElement('div');
    h.innerHTML = html;
    var fresh = h.querySelector('#cart-icon-bubble');
    var live = document.getElementById('cart-icon-bubble');
    if (fresh && live) live.innerHTML = fresh.innerHTML;
  }

  /* Formulaires d'achat marqués [data-syc-atc] (bloc d'achat de l'advertorial 2) :
     le tiroir s'ouvre AVANT l'aller-retour réseau, squelette en place, comme chez
     Somnair Pet. Sans JS ou sans tiroir, le formulaire part normalement vers /cart. */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form[data-syc-atc]');
    if (!form || !drawer() || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    openDrawer(true);
    if (btn) btn.disabled = true;
    var fd = new FormData(form);
    /* Un selling_plan vide est refusé par Shopify : on ne l'envoie que rempli. */
    if (fd.has('selling_plan') && !fd.get('selling_plan')) fd.delete('selling_plan');
    fd.append('sections', 'cart-drawer,cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);
    fetch(route('cart_add_url', '/cart/add') + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var html = res && res.sections && res.sections['cart-drawer'];
        if (html) { swapDrawer(html); majBulle(res.sections['cart-icon-bubble']); }
        else refreshDrawer();
      })
      .catch(function () { refreshDrawer(); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ============================================== REPEINT APRÈS UNE MUTATION */

  var GHOST_CAP = 900;

  /* Photo de l'ancien tiroir posée par-dessus le nouveau, retirée dès que le
     récapitulatif est revenu : réservée au pré-cochage automatique, qui repeint
     pendant que le client découvre son tiroir. */
  function snapshot() {
    var live = document.querySelector('#CartDrawer .drawer__inner');
    if (!live || !live.querySelector('.syc-cs')) return null;
    var ghost = document.createElement('div');
    ghost.className = 'syc-ghost';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.innerHTML = live.innerHTML;
    var i, nodes = ghost.querySelectorAll('[id], [data-syc-prot], [data-syc-up], [data-syc-xs]');
    for (i = 0; i < nodes.length; i++) {
      nodes[i].removeAttribute('id');
      nodes[i].removeAttribute('data-syc-prot');
      nodes[i].removeAttribute('data-syc-up');
      nodes[i].removeAttribute('data-syc-xs');
    }
    return ghost;
  }

  function showGhost(ghost) {
    var live = ghost && document.querySelector('#CartDrawer .drawer__inner');
    if (!live) return;
    live.appendChild(ghost);
    var started = Date.now();
    var tick = setInterval(function () {
      var l = document.querySelector('#CartDrawer .drawer__inner');
      if (!l || !l.contains(ghost)) return clearInterval(tick);
      var rebuilt = false, seen = l.querySelectorAll('.syc-cs');
      for (var k = 0; k < seen.length; k++) {
        if (!ghost.contains(seen[k])) { rebuilt = true; break; }
      }
      if (rebuilt || Date.now() - started > GHOST_CAP) {
        clearInterval(tick);
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      }
    }, 50);
  }

  /* Le pied perd son récapitulatif à chaque repaint : on RÉSERVE sa hauteur le
     temps qu'il revienne (1,2 s au plus), sinon le tiroir se tasse puis se rouvre. */
  function holdFooter(live) {
    var footer = live.querySelector(FOOTER_SEL);
    if (!footer || !footer.querySelector('.syc-cs')) return 0;
    return footer.getBoundingClientRect().height;
  }

  function releaseFooter(live, held) {
    var footer = held && live.querySelector(FOOTER_SEL);
    if (!footer) return;
    if (footer.querySelector('.syc-cs')) return;
    footer.style.minHeight = held + 'px';
    var started = Date.now();
    var tick = setInterval(function () {
      var f = live.querySelector(FOOTER_SEL);
      if (!f) return clearInterval(tick);
      if (f.querySelector('.syc-cs') || Date.now() - started > 1200) {
        f.style.minHeight = '';
        clearInterval(tick);
      }
    }, 100);
  }

  function refresh(d, response) {
    /* Toujours depuis "/" : sur /products/*, `Accept: application/json` rend le produit. */
    return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var holder = document.createElement('div');
        holder.innerHTML = data['cart-drawer'] || '';
        var fresh = holder.querySelector('.drawer__inner');
        var live = document.querySelector('#CartDrawer .drawer__inner');
        if (!fresh || !live) throw new Error('drawer introuvable');
        var scroll = live.scrollTop;
        var held = holdFooter(live);
        live.innerHTML = fresh.innerHTML;
        live.scrollTop = scroll;
        releaseFooter(live, held);
        if (d && response) d.classList.toggle('is-empty', response.item_count === 0);
        majBulle(data['cart-icon-bubble']);
        ensureSkin();
      });
  }

  function paint(d, response, freeze) {
    var ghost = freeze ? snapshot() : null;
    var sections = response && response.sections;
    if (d && typeof d.renderContents === 'function' &&
        sections && typeof sections === 'object' && Object.keys(sections).length) {
      if (typeof d.setActiveElement === 'function') d.setActiveElement(document.activeElement);
      d.classList.toggle('is-empty', response.item_count === 0);
      var before = document.querySelector('#CartDrawer .drawer__inner');
      var kept = before ? holdFooter(before) : 0;
      d.renderContents(response);
      var after = document.querySelector('#CartDrawer .drawer__inner');
      if (after) releaseFooter(after, kept);
      showGhost(ghost);
      ensureSkin();
      return Promise.resolve();
    }
    return refresh(d, response).then(function () { showGhost(ghost); },
                                      function (e) { showGhost(ghost); throw e; });
  }

  function noteErreur(msg) {
    var box = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
    if (box) box.textContent = msg;
  }

  /* ============================================ ÉCHANGE ONE-TIME -> ABONNEMENT
     Règles héritées de Somnair (mesure du 24/09) : la clé de ligne rendue par le
     Liquid ne survit pas à l'ajout de la même variante -> on relit /cart.js et on
     agit par NUMÉRO DE LIGNE ; si le retrait échoue on ANNULE l'ajout ; jamais de
     reload. */
  var UP_ESSAIS = 3;
  var UP_ERR = 'We couldn’t switch that item to a subscription — please check your cart and try again.';

  function lineOf(cart, key, variantId, abo) {
    var i, it, repli = 0;
    for (i = 0; i < cart.items.length; i++) {
      it = cart.items[i];
      if (!!it.selling_plan_allocation !== abo) continue;
      if (key && it.key === key) return i + 1;
      if (!repli && it.variant_id === variantId) repli = i + 1;
    }
    return repli;
  }

  function setLine(d, cible, calc, essai) {
    essai = essai || 1;
    return cartRead()
      .then(function (cart) {
        var n = lineOf(cart, cible.key, cible.variantId, cible.abo);
        if (!n) return null;
        var item = cart.items[n - 1];
        var q = calc(item);
        if (q === item.quantity) return null;
        return post(route('cart_change_url', '/cart/change'), withSections({ line: n, quantity: q }, d))
          .catch(function (e) {
            if (essai < UP_ESSAIS) throw e;
            var u = {};
            u[item.key] = q;
            return post(route('cart_update_url', '/cart/update') + '.js', withSections({ updates: u }, d));
          });
      })
      .catch(function (e) {
        if (essai >= UP_ESSAIS) throw e;
        return attendre(300 * essai).then(function () { return setLine(d, cible, calc, essai + 1); });
      });
  }

  /* Remplace une ligne par une autre : AJOUT de la nouvelle, puis RETRAIT de l'ancienne
     (relue dans /cart.js, par numéro de ligne). Si le retrait échoue, on annule l'ajout :
     deux lignes, ce serait le client qui paie deux fois. Sert à deux boutons :
       · [data-syc-up]  one-time -> abonnement, même variante ;
       · [data-syc-upg] palier -> palier supérieur (1x -> 2x, 2x -> 3x), même mode. */
  function swapLine(d, ancienne, nouvelle, qty, bouton, msg) {
    var ajout = null;
    function liberer() {
      var b = document.querySelector(bouton);
      if (b) b.removeAttribute('aria-busy');
    }
    return post(route('cart_add_url', '/cart/add'), { items: [nouvelle] })
      .then(function (r) {
        ajout = (r && r.items && r.items[0]) || null;
        return setLine(d, ancienne, function () { return 0; });
      })
      .then(function (response) { return paint(d, response || null); })
      .then(liberer)
      .catch(function () {
        var annule = ajout
          ? setLine(d, { key: ajout.key, variantId: nouvelle.id, abo: !!nouvelle.selling_plan },
                    function (it) { return Math.max(0, it.quantity - qty); })
          : Promise.resolve(null);
        return annule
          .catch(function () {})
          .then(function () { return refresh(d, null).catch(function () {}); })
          .then(function () { noteErreur(msg); liberer(); });
      });
  }

  function upgradeToSub(d, key, to, qty, plan) {
    var ligne = { id: to, quantity: qty };
    if (plan) ligne.selling_plan = plan;
    return swapLine(d, { key: key, variantId: to, abo: false }, ligne, qty, '[data-syc-up]', UP_ERR);
  }

  /* ================================================== CONTRÔLES DU TIROIR */
  document.addEventListener('click', function (evt) {
    if (!evt.target || !evt.target.closest) return;
    var d = drawer();

    /* 1. one-time -> abonnement (même variante) */
    var up = evt.target.closest('[data-syc-up]');
    if (up) {
      evt.preventDefault();
      if (up.getAttribute('aria-busy') === 'true') return;
      var to = parseInt(up.getAttribute('data-syc-to'), 10);
      var qty = parseInt(up.getAttribute('data-syc-qty'), 10) || 1;
      var plan = parseInt(up.getAttribute('data-syc-plan'), 10);
      if (!to) return;
      up.setAttribute('aria-busy', 'true');
      noteErreur('');
      upgradeToSub(d, up.getAttribute('data-syc-key'), to, qty, plan);
      return;
    }

    /* 1 bis. UPGRADE : palier supérieur, même parfum, même mode (abonnement ou non) */
    var upg = evt.target.closest('[data-syc-upg]');
    if (upg) {
      evt.preventDefault();
      if (upg.getAttribute('aria-busy') === 'true') return;
      var vers = parseInt(upg.getAttribute('data-syc-to'), 10);
      var depuis = parseInt(upg.getAttribute('data-syc-from'), 10);
      var q = parseInt(upg.getAttribute('data-syc-qty'), 10) || 1;
      var pl = parseInt(upg.getAttribute('data-syc-plan'), 10);
      if (!vers || !depuis) return;
      var nouvelle = { id: vers, quantity: q };
      if (pl) nouvelle.selling_plan = pl;
      upg.setAttribute('aria-busy', 'true');
      noteErreur('');
      swapLine(d, { key: upg.getAttribute('data-syc-key'), variantId: depuis, abo: upg.getAttribute('data-syc-abo') === '1' },
               nouvelle, q, '[data-syc-upg]', 'We couldn’t upgrade that item — please check your cart and try again.');
      return;
    }

    /* 2. switch Priority Shipping & Protection (plus rendu depuis le 06/10, gardé inerte) */
    var prot = evt.target.closest('[data-syc-prot]');
    if (prot) {
      evt.preventDefault();
      if (prot.getAttribute('aria-busy') === 'true') return;
      var on = prot.getAttribute('aria-checked') === 'true';
      var payload, url;
      if (on) {
        var protKey = prot.getAttribute('data-syc-key');
        if (!protKey) return;
        url = route('cart_change_url', '/cart/change');
        payload = { id: protKey, quantity: 0 };
      } else {
        var protId = parseInt(prot.getAttribute('data-syc-id'), 10);
        if (!protId) return;
        url = route('cart_add_url', '/cart/add');
        payload = { items: [{ id: protId, quantity: 1 }] };
      }
      prot.setAttribute('aria-busy', 'true');
      rememberChoice(on);
      /* Flip optimiste : la bascule répond au doigt, pas au réseau. */
      prot.setAttribute('aria-checked', on ? 'false' : 'true');
      post(url, withSections(payload, d))
        .then(function (response) { return paint(d, response); })
        .catch(function () {
          prot.setAttribute('aria-checked', on ? 'true' : 'false');
          prot.removeAttribute('aria-busy');
        });
      return;
    }

    /* 3. cross-sell : ajoute l'autre parfum. `data-syc-plan` est rempli seulement si
       la ligne déjà au panier est un abonnement — la carte le dit en clair. */
    var xs = evt.target.closest('[data-syc-xs]');
    if (xs) {
      evt.preventDefault();
      if (xs.getAttribute('aria-busy') === 'true') return;
      var xsId = parseInt(xs.getAttribute('data-syc-id'), 10);
      if (!xsId) return;
      var l = { id: xsId, quantity: 1 };
      var xsPlan = parseInt(xs.getAttribute('data-syc-plan'), 10);
      if (xsPlan) l.selling_plan = xsPlan;
      xs.setAttribute('aria-busy', 'true');
      post(route('cart_add_url', '/cart/add'), withSections({ items: [l] }, d))
        .then(function (response) { return paint(d, response); })
        .catch(function () {
          return refresh(d, null).catch(function () {}).then(function () {
            noteErreur('We couldn’t add that item — please try again.');
          });
        });
    }
  });

  /* Le thème émet `cartQuantityUpdated` MÊME quand la mutation a échoué : on
     repart alors de l'état réel du panier au lieu de laisser le tiroir mentir. */
  document.addEventListener('cartQuantityUpdated', function () {
    var box = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
    if (!box || !box.textContent.trim()) return;
    refresh(drawer()).catch(function () {});
  });

  /* ======================================================================
     PRÉ-COCHAGE de la protection + garde « protection seule »
     Repris de Somnair (posé le 12/08, rétabli le 18/08 à la demande de Zeid).
     ⚖️ Une case pré-cochée qui ajoute un frais est attaquable côté US (FTC,
     negative option) : choix assumé chez Somnair, repris ici à l'identique.
     Pour le désarmer : `return;` en tête d'autoProtect().
     Garde-fous : refus mémorisé pour l'onglet, UNE pose par chargement (/cart/add
     incrémente), échec SILENCIEUX (un reload sur 429 anti-bot boucle), et
     confirmAlone() relit /cart.js avant de vider un panier d'assurance seule.
     ====================================================================== */
  var autoBusy = false;
  var autoAdded = false;
  var aloneChecked = false;

  function optedOut() {
    try { return sessionStorage.getItem(PROT_OPTOUT) === '1'; } catch (e) { return false; }
  }

  function rememberChoice(wasOn) {
    try {
      if (wasOn) sessionStorage.setItem(PROT_OPTOUT, '1');
      else sessionStorage.removeItem(PROT_OPTOUT);
    } catch (e) { /* stockage indisponible */ }
  }

  function autoProtect() {
    if (autoBusy || autoAdded || optedOut()) return;
    var scope = document.getElementById('CartDrawer');
    if (!scope) return;
    var row = scope.querySelector('[data-syc-prot]');
    if (!row || row.getAttribute('aria-checked') === 'true') return;
    var protId = parseInt(row.getAttribute('data-syc-id'), 10);
    if (!protId) return;
    var d = drawer();
    autoAdded = true;
    autoBusy = true;
    row.setAttribute('aria-checked', 'true');
    post(route('cart_add_url', '/cart/add'), withSections({ items: [{ id: protId, quantity: 1 }] }, d))
      .then(function (response) { return paint(d, response, true); })
      .catch(function () {
        try { row.setAttribute('aria-checked', 'false'); } catch (e) {}
      })
      .then(function () { autoBusy = false; });
  }

  function looksAlone(scope) {
    var prot = scope.querySelectorAll('.cart-item--product-' + PROT_HANDLE);
    if (!prot.length) return false;
    return scope.querySelectorAll('.cart-item').length === prot.length;
  }

  function confirmAlone() {
    return cartRead().then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) return false;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].handle !== PROT_HANDLE) return false;
      }
      return true;
    });
  }

  function cartGuard() {
    if (autoBusy) return;
    var scope = document.getElementById('CartDrawer');
    if (!scope) return;
    var d = drawer();
    if (!looksAlone(scope)) { aloneChecked = false; return; }
    if (aloneChecked) return;
    aloneChecked = true;
    autoBusy = true;
    confirmAlone()
      .then(function (alone) {
        if (!alone) return null;
        return post(route('cart_clear_url', '/cart/clear'), withSections({}, d))
          .then(function (response) { return paint(d, response); });
      })
      .catch(function () {})
      .then(function () { autoBusy = false; });
  }

  /* 06/10/2026 — PLUS DE PROTECTION (demande de Zeid). La rangée n'est plus rendue et
     autoProtect() n'est plus appelé. Reste à nettoyer les paniers qui en portent déjà une :
     sans rangée, le client ne pourrait plus la décocher et paierait 3,99 $ sans la voir.
     Une seule tentative par chargement ; échec silencieux (un reload sur 429 boucle). */
  var purgeFaite = false;

  function purgeProtection() {
    if (autoBusy || purgeFaite) return;
    var scope = document.getElementById('CartDrawer');
    if (!scope || !scope.querySelector('.cart-item--product-' + PROT_HANDLE)) return;
    purgeFaite = true;
    autoBusy = true;
    var d = drawer();
    cartRead()
      .then(function (cart) {
        var n = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].handle === PROT_HANDLE) { n = i + 1; break; }
        }
        if (!n) return null;
        return post(route('cart_change_url', '/cart/change'), withSections({ line: n, quantity: 0 }, d))
          .then(function (response) { return paint(d, response); });
      })
      .catch(function () {})
      .then(function () { autoBusy = false; });
  }

  function tick() {
    purgeProtection();
  }

  function boot() {
    var cd0 = drawer();
    if (cd0) goalBar(cd0);
    if (cd0 && cd0.querySelector('.cart-item')) skinDrawer();
    tick();
    if (typeof MutationObserver === 'undefined') return;
    /* Observé sur body, PAS sur #CartDrawer : Shrine REMPLACE ce nœud au repaint
       (mesuré chez Somnair le 12/08 : l'observateur accroché à l'ancien voyait 0
       mutation). */
    var pending = null;
    new MutationObserver(function (muts) {
      /* Seules les mutations DU TIROIR comptent : un carrousel ou un widget qui mute
         la page en continu ne doit déclencher ni lecture du panier ni passe de garde. */
      var cd = drawer();
      if (!cd) return;
      var dedans = false;
      for (var i = 0; i < muts.length; i++) {
        if (cd.contains(muts[i].target)) { dedans = true; break; }
      }
      if (!dedans) return;
      ensureSkin();
      if (autoBusy || pending) return;
      pending = setTimeout(function () { pending = null; tick(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
